import React from "react";
import { SnackbarProvider } from "notistack";
import ListingSelectionsComponent from "../../Components/listingSelectionsComponent";
import ListingSelectionsComponentNew from "../../Components/listingSelectionsComponentNew";
const ListingSelections = () => {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          {/* <ListingSelectionsComponent/> */}
          <ListingSelectionsComponentNew />
        </div>
      </div>
    </SnackbarProvider>
  );
};

export default ListingSelections;
